/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React from "react";
// import { useState } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Typography } from "@material-ui/core";
// import useStyles from "../Theme_1/ComponentCss";
import ThemeControls from "../AllThemesControl";

import { hasChildren } from "./utils";

//routing-imports
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom'//importing for getting current location. 
// import { HvacOutlined } from "@mui/icons-material";

export default function MenuRender(_obj) {
  // const { useStyles } = ThemeControls;
  // const classes = useStyles();

  // let returnObject = null;
  let MenuObj = _obj.menuJson;

  return MenuObj.menus.map((obj, key) => {
    let _thiJson = MenuObj.menus[key];
    return <MenuTitle key={key} MenuItems={_thiJson} sideMenuOpen={_obj.sideMenuOpen} />;
  });
}


//***********************/

const MenuItem = ({ item, index, sideMenuOpen }) => {
  const Component = hasChildren(item) ? MultiLevel : SingleLevel;
  return <Component item={item} index={index} sideMenuOpen={sideMenuOpen} />;
};


//***********************/

const MenuTitle = ({ MenuItems, sideMenuOpen }) => {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  let navigate = useNavigate();

  const handleClickChild = () => {
    navigate(MenuItems.path);
  };

  if (!MenuItems) {
    return <></>;
  }

  return (
    <>
      <Typography variant="h3" className={classes.menuHead} color="primary">
        {MenuItems.MenuTitle}
      </Typography>
      <div className={classes.menuFont}>
        {MenuItems.item.map((child, index) => (
          <MenuItem
            key={index}
            item={child}
            onClick={handleClickChild}
            sideMenuOpen={sideMenuOpen} // Pass the sideMenuOpen prop here
          />
        ))}
      </div>
    </>
  );
};


//***********************/

const SingleLevel = ({ item,index,sideMenuOpen}) => {
  const {useStyles} = ThemeControls;
  const classes = useStyles();
   
   

  let navigate = useNavigate();
  const location = useLocation();

  //handle click . ...
  const handleClick = () => {
    navigate(item.path);
    sideMenuOpen();
  };

  return (
    item.auth&&<ListItem button onClick={handleClick}  className={
      ((index===undefined))
      &&
      (String(location.pathname).match(String(item.path))) ?
       `${classes.activeMenu}`:
        ''} >
      <ListItemIcon>{item.icon}</ListItemIcon>
      <ListItemText primary={item.title} />
    </ListItem>
  );
};

//***********************/

const MultiLevel = ({ item,index,sideMenuOpen}) => {
  const {useStyles} = ThemeControls;
  const classes = useStyles();
  const { items: children } = item;

  //routing-stateT
  let navigate = useNavigate();
  const location = useLocation();///location---> current path.

  //onclick
  const handleClick = () => {
     
    // sideMenuOpen()
    navigate(item.path);
  };

  return (
        <React.Fragment >
          {item.auth&&<ListItem button onClick={handleClick} className={(String(location.pathname).match(String(item.path))) ? `${classes.activeMenu}`: ''}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.title} />
            {/* {open ? <ExpandLessIcon /> : <ExpandMoreIcon />} */}
            {/* {item.path !== location.pathname ? <ExpandLessIcon /> : <ExpandMoreIcon />} */}
            {String(location.pathname).match(String(item.path)) ?  <ArrowRightIcon/>:<ArrowDropDownIcon />}
          </ListItem>}
          <Collapse in={String(location.pathname).match(String(item.path))} timeout="auto" unmountOnExit >
            <List component="div" disablePadding >
              {children.map((child, index) => (
                <MenuItem key={index} item={child} index={index} sideMenuOpen={sideMenuOpen}/>
              ))}
            </List>
          </Collapse>
        </React.Fragment>
  );
};


